export { default as Dynamic } from './Dynamic';
